/* *************************************************************** *
 * THIS IS AN AUTO GENERATED FILE. PLEASE DO NOT EDIT IT DIRECTLY.
 *
 * If you want to change this Icon component , it is generated
 * from the `iconTamplate.js` file the parent directory.
 * *************************************************************** */
/* eslint-disable */
import React from 'react';
import { useFela, } from 'react-fela';
import iconStyle from '../iconStyle';
import { iconPropTypes, iconDefaultProps, } from '../iconPropTypes';

export default function IconLogout({ size, fill, color, attrs, miscStyles, ...props }) {
  const className = useFela({ size, fill, color, miscStyles, }).css(iconStyle);

  return (
    <svg width="1em" height="1em" viewBox="0 0 256 256" className={className} {...props} {...attrs} data-test="IconLogout">  <path fill="currentColor" d="M227.4 130L158 198.7l-16.5-16.8 41.2-39.9H85v-24h97.6l-40.1-40.9L159 60.3l68.4 69.7zM54 65h56V41H30v176h80v-24H54V65z" /></svg>
  );
}

IconLogout.propTypes = iconPropTypes;
IconLogout.defaultProps = iconDefaultProps;
